'use client';

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger, } from "@/components/ui/accordion";
import { useTranslations } from "next-intl";

export const FAQ_ITEM_KEYS = [
  'east_and_west_medicine_difference',
  'tibetmed_history',
  'analysis_xrays_needed',
  'acupuncture_painful',
  'treatment_guarantee',
  'complex_treatment',
  'first_procedure_effects',
  'how_to_choose_doctor',
] as const;

export type FaqItemKey = typeof FAQ_ITEM_KEYS[number];

export type FaqItem = {
  id: number;
  key: FaqItemKey;
};

const faqItems: readonly FaqItem[] = [
  { id: 0, key: 'east_and_west_medicine_difference' },
  { id: 1, key: 'tibetmed_history' },
  { id: 2, key: 'analysis_xrays_needed' },
  { id: 3, key: 'acupuncture_painful' },
  { id: 4, key: 'treatment_guarantee' },
  { id: 5, key: 'complex_treatment' },
  { id: 6, key: 'first_procedure_effects' },
  { id: 7, key: "how_to_choose_doctor" },
] as const;

export default function FaqSection() {
  const t = useTranslations('faq_section');

  return (
    <Accordion type="single" collapsible>
      {faqItems.map((item, index) => (
        <AccordionItem key={index} value={`item-${index}`}>
          <AccordionTrigger className="font-semibold hover:no-underline">
            {t(`items.${item.key}.question`)}
          </AccordionTrigger>
          <AccordionContent className="text-muted-foreground">
            {t(`items.${item.key}.answer`)}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
};
